import { Col, ELanguage } from '@microfrontends/react-components'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import BottomSection from '../../components/CareerPath/Landing/BottomSection'
import FixedBottomButton from '../../components/Numerology/FixedBottomButton'
import ModalFormNumerology from '../../components/Numerology/ModalFormNumerology'
import AppContext from '../../context/AppContext'
import NumerologyApi from '../../services/numerology'
import {
	IDataChartNumerology,
	IFamousPeople,
	IRulingNumber
} from '../../services/numerology/@type'
import RecommendJobs from '../NumerologyContainerV2/components/RecommendJobs'
import { Container } from './RulingNumberDetail.css'
import Detail from './components/Detail'
import FamosPeole from './components/FamosPeople'
import MostCV from './components/MostCV'
import SlideRulingNumber from './components/SlideRulingNumber'
import TopJobs from './components/TopJobs'
import { showLoginModal } from '../../helpers/buildLoginUrl'

const BASE_URL = process.env.VNW_BASE_URL
const IMAGE_SERVICE = process.env.IMAGE_BASE_URL + '/images/numerology'
const UTM = {
	utm_source: 'numerology',
	utm_medium: 'job-will-love',
	utm_campaign: 'detail'
}

const CAREER_PATH_UTM = {
	utm_source_navi: 'banner',
	utm_medium_navi: 'session',
	utm_campaign_navi: 'CP2023'
}

interface IRulingNumberDetailContainerProps {
	rulingNumberList: IRulingNumber[]
	famousPeople: IFamousPeople[]
	rulingNumberJobs: IDataChartNumerology[]
	isRobot: boolean
}
export default function RulingNumberDetailContainer({
	famousPeople,
	isRobot,
	rulingNumberJobs,
	rulingNumberList
}: IRulingNumberDetailContainerProps) {
	const { user, languageCode = ELanguage.VI } = useContext(AppContext)
	const router = useRouter()
	const { rulingNumberId } = router.query
	const [openModal, setOpenModal] = useState(false)
	const [rulingNumbers, setRulingNumbers] = useState<IRulingNumber[]>(
		rulingNumberList
	)

	const handleOpenModal = () => {
		if (!user?.accessToken || user?.accessToken === '') {
			showLoginModal(languageCode)
			return
		}
		setOpenModal(!openModal)
	}
	const getListRulingNumber = async () => {
		try {
			const list = await NumerologyApi.getRulingNumberList()
			if (list) {
				setRulingNumbers(list)
				return
			}
		} catch (error) {
			console.error(error)
		}
	}

	/*
	 * VNW-21084: [Web][Numerlogy] Add "Career path" banner.
	 * Author: PhongGP
	 * Since: 21 Mar, 2023
	 *  */
	const path =
		languageCode === ELanguage.VI ? '/lo-trinh-su-nghiep' : '/career-path'
	const href =
		process.env.VNW_BASE_URL +
		path +
		'?' +
		new URLSearchParams(CAREER_PATH_UTM).toString()

	useEffect(() => {
		getListRulingNumber()
	}, [])

	const getRulingNumber = () => {
		const rulingNumber = rulingNumbers
			? rulingNumbers?.filter(
					(elm) => elm.number === Number(rulingNumberId)
			  )[0]
			: null
		return rulingNumber
	}
	return (
		<Container>
			<Col>
				<SlideRulingNumber handleOpen={handleOpenModal} />
			</Col>
			<Col>
				<Detail numberMeaning={getRulingNumber()} />
			</Col>
			<Col>
				<FamosPeole
					rulingNumber={Number((rulingNumberId as string) ?? 0)}
					famousPeople={famousPeople}
					isRobot={isRobot}
				/>
			</Col>
			<Col>
				<TopJobs
					rulingNumber={Number((rulingNumberId as string) ?? 0)}
					descriptionPersonalities={
						getRulingNumber()?.descriptionPersonalities ?? ''
					}
					rulingNumberJobs={rulingNumberJobs}
				/>
			</Col>
			<Col>
				<RecommendJobs
					title='VIỆC LÀM TỐT NHẤT NHÂN SỐ HỌC GỢI Ý'
					utm={UTM}
				/>
			</Col>
			<Col>
				<MostCV />
			</Col>
			<ModalFormNumerology open={openModal} onClose={handleOpenModal} />
			<FixedBottomButton />
			<Col>
				<BottomSection
					redirectLink={href}
					backGroundPath={`${IMAGE_SERVICE}/bottom-section-background.png`}
					bannerPath={`${IMAGE_SERVICE}/bottom-section-image.png`}
				/>
			</Col>
		</Container>
	)
}
